module.exports = __webpack_public_path__ + "static/media/logo-sensa.3111e687.svg";